import React from "react";

export default function Footer() {
  return (
    <footer className="bg-black text-white/70 text-center px-6 py-10 mt-auto" style={{ fontSize: "12px", lineHeight: "1.6" }}>
      <div className="max-w-2xl mx-auto space-y-4">
        <p>
          This fundraiser is organized by{" "}
          <a href="https://PSPeople.org" target="_blank" rel="noopener noreferrer" className="text-white underline hover:text-white/90">
            Providence Serving People
          </a>{" "}
          (PSP), a registered 501(c)(3) nonprofit, in support of Buchtel Griffins youth baseball in
          Akron, Ohio — proudly supported by the Buchtel Baseball Booster Club. Donations are processed
          securely through Stripe. Platform built and managed by Shooin Company LLC on behalf of PSP.
        </p>
        <p>
          Questions? Contact us at{" "}
          <a href="mailto:jedwards@pspeople.org" className="text-white underline hover:text-white/90">
            jedwards@pspeople.org
          </a>
          {" | "}
          <a href="https://PSPeople.org" target="_blank" rel="noopener noreferrer" className="text-white underline hover:text-white/90">
            PSPeople.org
          </a>
        </p>
      </div>
    </footer>
  );
}
